import { render, staticRenderFns } from "./UDIOutlistChildOld.vue?vue&type=template&id=5a34ef7e&scoped=true"
import script from "./UDIOutlistChildOld.vue?vue&type=script&lang=js"
export * from "./UDIOutlistChildOld.vue?vue&type=script&lang=js"
import style0 from "./UDIOutlistChildOld.vue?vue&type=style&index=0&id=5a34ef7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a34ef7e",
  null
  
)

export default component.exports